<template>
  <img v-if="!hasError" class="in-dm-image" :src="url" :alt="fileName" @error="onError" />
  <div v-else class="in-dm-image in-dm-image--fallback">
    <Icon name="image-outline" class="in-dm-image__icon" aria-hidden="true" />
    <span class="in-dm-image__text">画像を読み込めません</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import { useErrorState } from '@/client/components/_hooks/useErrorState'
import { extractFileName } from '@/client/utils/string'

interface Props {
  url: string
}
const props = defineProps<Props>()

const { hasError, onError } = useErrorState()
const fileName = computed(() => extractFileName(props.url))
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/in-dm.scss' as *;
@use '@/client/assets/scss/variables.scss' as *;

.in-dm-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.in-dm-image--fallback {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $in-dm-media-fail-text;
  background: $in-dm-media-fail-bg;
}

.in-dm-image__icon {
  width: auto;
  height: auto;
  font-size: 40px;
}

.in-dm-image__text {
  position: absolute;
  top: 75%;
  left: 50%;
  font-size: $font-small-size;
  white-space: nowrap;
  transform: translate(-50%, -50%);
}
</style>
